export default __webpack_public_path__ + "static/media/Java.4ad0c6e7.svg";